<template>
    <div>

      <!-- Top Bar -->
      <nav class="navbar">
          <div class="container-fluid">
              <div class="navbar-header">
                  <a href="javascript:void(0);" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar-collapse" aria-expanded="false"></a>
                  <a href="javascript:void(0);" class="bars"></a>
                  <!-- <a class="navbar-brand" href="/">e-GOVENMENT - KAB.KONSEL</a> -->
                  <router-link class="navbar-brand" to="/">e-GOVENMENT - KAB.KONSEL</router-link>
              </div>
              <div class="collapse navbar-collapse" id="navbar-collapse">
                    <ul class="nav navbar-nav navbar-right">
                        <!-- Call Search -->
                        <li>
                            <router-link to="/"><i class="material-icons">home</i></router-link>
                        </li>
                        <!-- #END# Call Search -->
                        <li>
                            <a href="javascript:void(0);" title="Refresh Halaman" @click="reloadPage()"><i class="material-icons">refresh</i></a>
                        </li>
                        <!-- Notifications -->
                        <li class="dropdown">
                            <a href="javascript:void(0);" class="dropdown-toggle" data-toggle="dropdown" role="button">
                                <i class="material-icons">notifications</i>
                                <span class="label-count">2</span>
                            </a>
                            <ul class="dropdown-menu">
                                <li class="header">PEMBERITAHUAN</li>
                                <li class="body">
                                    <ul class="menu">
                                        <li>
                                            <a href="javascript:void(0);">
                                                <div class="icon-circle bg-light-green">
                                                    <i class="material-icons">person_add</i>
                                                </div>
                                                <div class="menu-info">
                                                    <h4>12 new members joined</h4>
                                                    <p>
                                                        <i class="material-icons">access_time</i> 14 mins ago
                                                    </p>
                                                </div>
                                            </a>
                                        </li>

                                        <li>
                                            <a href="javascript:void(0);">
                                                <div class="icon-circle bg-purple">
                                                    <i class="material-icons">settings</i>
                                                </div>
                                                <div class="menu-info">
                                                    <h4>Settings updated</h4>
                                                    <p>
                                                        <i class="material-icons">access_time</i> Yesterday
                                                    </p>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                                <li class="footer">
                                    <a href="javascript:void(0);">View All Notifications</a>
                                </li>
                            </ul>
                        </li>
                        <!-- #END# Notifications -->
                        <!-- Tasks -->

                        <!-- #END# Tasks -->
                        <li class="pull-right"><a href="javascript:void(0);" class="js-right-sidebar" data-close="true"><i class="material-icons">more_vert</i></a></li>
                    </ul>
              </div>
          </div>
      </nav>
      <!-- #Top Bar -->


    </div>
</template>


<script>
    export default {
        name: 'monev_topbar',
            data () {
                return {
                    msg: 'monev_topbar',
                    apakah: 'Telasomu'
                }
            },
            methods: {
                reloadPage : function(){
                    window.location.reload();
                },
            },
    }
</script>
